console.log("Custom Scripts Loaded");

document.addEventListener("DOMContentLoaded", function () {
  initHeroAnimation();
  initScrollReveals();
});


/*////////////////////////////////*/
/*//////// HERO ANIMATION ////////*/
/*////////////////////////////////*/

function initHeroAnimation() {
  const hero = document.querySelector(
    "#shopify-section-template--26675979682098__section_6PnLrM"
  );

  if (!hero) return;

  const logo = hero.querySelector(
    ".image-block--ASEhRQ3BlMTFxSDRDM__image_HTwbh6"
  );

  const butterflies = hero.querySelector(
    ".custom-section-background .background-image-container"
  );

  if (!logo || !butterflies) {
    console.warn("Hero elements not found");
    return;
  }

  let previousProgress = -1;

  function animateLogo() {
    if (window.innerWidth < 800) {
      logo.style.removeProperty("transform");
      logo.style.removeProperty("opacity");
      butterflies.style.removeProperty("transform");

      previousProgress = -1;

      window.requestAnimationFrame(animateLogo);
      return;
    }

    const heroRect = hero.getBoundingClientRect();

    const scrollDistance = Math.max(
      hero.offsetHeight - window.innerHeight,
      1
    );

    const progress = Math.min(
      Math.max(-heroRect.top / scrollDistance, 0),
      1
    );

    /*
      Only update the DOM when progress actually changes.
    */
    if (Math.abs(progress - previousProgress) > 0.001) {
      const logoMove = progress * -350;
      const logoScale = 1 - progress * 0.18;
      const logoOpacity = 1 - progress * 0.15;

      const butterflyMove = progress * 70;

      logo.style.setProperty(
        "transform",
        `translate3d(0, ${logoMove}px, 0) scale(${logoScale})`,
        "important"
      );

      logo.style.setProperty(
        "opacity",
        String(logoOpacity),
        "important"
      );

      butterflies.style.setProperty(
        "transform",
        `translate3d(0, ${butterflyMove}px, 0)`,
        "important"
      );

      previousProgress = progress;
    }

    window.requestAnimationFrame(animateLogo);
  }

  window.requestAnimationFrame(animateLogo);
}


/*////////////////////////////////*/
/*//////// SCROLL REVEALS ////////*/
/*////////////////////////////////*/

function initScrollReveals() {
  const introContent = document.querySelector(
    "#shopify-section-template--26675979682098__hero_mBw9MR .hero__content-wrapper"
  );

  const categoryCards = document.querySelectorAll(
    "#shopify-section-template--26675979682098__section_LWqLq4 .group-block"
  );

  const newReleasesSection = document.querySelector(
    "#shopify-section-template--26675979682098__product_list_z7QLNk"
  );

  const collectionsSection = document.querySelector(
    "#shopify-section-template--26675979682098__collection_links_Vf8Xdj"
  );

  const aboutContent = document.querySelector(
    "#shopify-section-template--26675979682098__hero_eHAyKA .hero__content-wrapper"
  );

  introContent?.classList.add("scroll-reveal");
  newReleasesSection?.classList.add("scroll-reveal");
  collectionsSection?.classList.add("scroll-reveal");
  aboutContent?.classList.add("scroll-reveal");

  categoryCards.forEach((card) => {
    card.classList.add("scroll-reveal");
  });

  const revealElements = document.querySelectorAll(".scroll-reveal");

  if (!revealElements.length) return;

  const observer = new IntersectionObserver(
    (entries, revealObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add("is-visible");
        revealObserver.unobserve(entry.target);
      });
    },
    {
      threshold: 0.15,
      rootMargin: "0px 0px -10% 0px"
    }
  );

  revealElements.forEach((element) => {
    observer.observe(element);
  });
}